// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../common/Components/IconV5.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
let IsNewQueryParam = require("./IsNewQueryParam.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let MarketingProfileMembersList = require("./MarketingProfileMembersList.bs.js");
let TeamMarketingProfileMembersSettingsQuery_graphql = require("../../__generated__/TeamMarketingProfileMembersSettingsQuery_graphql.bs.js");
let TeamMarketingProfileMembersSettings_marketingProfile_graphql = require("../../__generated__/TeamMarketingProfileMembersSettings_marketingProfile_graphql.bs.js");
let TeamMarketingProfileMembersSettings_header_marketingProfile_graphql = require("../../__generated__/TeamMarketingProfileMembersSettings_header_marketingProfile_graphql.bs.js");

function TeamMarketingProfileMembersSettings$NoMembersState(props) {
  let match = IsNewQueryParam.use();
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(IconV5.make, {
            icon: "user-profile",
            className: "h-8 w-8 text-zinc-400"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: "You have not added any team members to your marketing profile yet.",
                className: "text-lg leading-6 font-medium text-zinc-900"
              }),
              JsxRuntime.jsx("p", {
                children: "You can add up to 8 team members.",
                className: "text-zinc-500"
              })
            ],
            className: "space-y-1 text-center"
          })
        ],
        className: "space-y-2 flex items-center flex-col"
      }),
      JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
        href: `/account/team_marketing_profile/members/new?is_new=` + (
          match[0] ? "1" : "0"
        ),
        size: "small",
        children: "Add member"
      })
    ],
    className: "flex flex-col items-center space-y-3 mt-8"
  });
}

let NoMembersState = {
  make: TeamMarketingProfileMembersSettings$NoMembersState
};

let convertFragment = TeamMarketingProfileMembersSettings_header_marketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileMembersSettings_header_marketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileMembersSettings_header_marketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, TeamMarketingProfileMembersSettings_header_marketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileMembersSettings_header_marketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function TeamMarketingProfileMembersSettings$Header(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(TeamMarketingProfileMembersSettings_header_marketingProfile_graphql.node, convertFragment, props.marketingProfile);
  let membersCount = marketingProfile.membersCount.totalCount;
  let match = IsNewQueryParam.use();
  let displayName = MarketingProfileSubpages.Page.Team.useDisplayName();
  let breadcrumbs = [
    {
      name: "Team Marketing Profile",
      href: "/account/team_marketing_profile"
    },
    {
      name: displayName("Members"),
      href: MarketingProfileSubpages.Page.Team.path("Members")
    }
  ];
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsx(Breadcrumbs.make, {
        pages: breadcrumbs
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h2", {
                children: "Marketing Profile Members",
                className: "text-zinc-800 text-3xl font-medium"
              }),
              JsxRuntime.jsx("p", {
                children: "Include up to 8 team members in your team marketing profile to give each their own page. This is separate from granting TAN access to team members as additional users on your account.",
                className: "text-base text-zinc-500"
              })
            ],
            className: "space-y-2"
          }),
          membersCount > 0 ? JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              href: `/account/team_marketing_profile/members/new?is_new=` + (
                match[0] ? "1" : "0"
              ),
              size: "small",
              children: "Add member"
            }) : null
        ],
        className: "\n        flex flex-col items-start gap-4 \n        sm:flex-row sm:items-end sm:gap-8\n        md:flex-col md:items-start md:gap-4\n        lg:flex-row lg:items-end lg:gap-8\n        justify-between"
      })
    ],
    className: "space-y-3 border-b pb-2"
  });
}

let Header = {
  Fragment: Fragment,
  make: TeamMarketingProfileMembersSettings$Header
};

let convertFragment$1 = TeamMarketingProfileMembersSettings_marketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileMembersSettings_marketingProfile_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileMembersSettings_marketingProfile_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, TeamMarketingProfileMembersSettings_marketingProfile_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileMembersSettings_marketingProfile_graphql.node, convertFragment$1, fRef);
}

let Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function TeamMarketingProfileMembersSettings$Page(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(TeamMarketingProfileMembersSettings_marketingProfile_graphql.node, convertFragment$1, props.marketingProfile);
  let membersCount = marketingProfile.membersCount.totalCount;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(TeamMarketingProfileMembersSettings$Header, {
          marketingProfile: marketingProfile.fragmentRefs
        }),
        JsxRuntime.jsx("div", {
          children: membersCount !== 0 ? JsxRuntime.jsx(MarketingProfileMembersList.make, {
              marketingProfile: marketingProfile.fragmentRefs
            }) : JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(TeamMarketingProfileMembersSettings$NoMembersState, {}),
              className: "mb-4"
            })
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              href: Scalars.URL.toString(marketingProfile.publicUrl),
              target: "_blank",
              size: "small",
              children: "View team profile"
            }),
            className: "flex items-baseline gap-6"
          }),
          className: "flex border-t border-zinc-200 pt-4"
        })
      ],
      className: ""
    }),
    className: "bg-white p-6 shadow-sm rounded space-y-8"
  });
}

let Page = {
  Fragment: Fragment$1,
  make: TeamMarketingProfileMembersSettings$Page
};

let convertVariables = TeamMarketingProfileMembersSettingsQuery_graphql.Internal.convertVariables;

let convertResponse = TeamMarketingProfileMembersSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = TeamMarketingProfileMembersSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use$2 = RescriptRelay_Query.useQuery(convertVariables, TeamMarketingProfileMembersSettingsQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, TeamMarketingProfileMembersSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(TeamMarketingProfileMembersSettingsQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(TeamMarketingProfileMembersSettingsQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(TeamMarketingProfileMembersSettingsQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(TeamMarketingProfileMembersSettingsQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$2,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function TeamMarketingProfileMembersSettings(props) {
  let match = use$2(undefined, undefined, undefined, undefined);
  let marketingProfile = match.currentAccountV5.marketingProfile;
  if (marketingProfile.__typename === "TeamMarketingProfile") {
    return JsxRuntime.jsx(TeamMarketingProfileMembersSettings$Page, {
      marketingProfile: marketingProfile.fragmentRefs
    });
  } else {
    return UnselectedUnionMemberError.raise(`Unselected union member: ` + marketingProfile._0);
  }
}

let make = TeamMarketingProfileMembersSettings;

exports.NoMembersState = NoMembersState;
exports.Header = Header;
exports.Page = Page;
exports.Query = Query;
exports.make = make;
/* use Not a pure module */
